type Props = {
  base64Photo: string;
};

const PhotoPreview = (props: Props) => {
  const { base64Photo } = props;

  return (
    <div className="photo-moderation__photo-preview">
      <img src={base64Photo} />
    </div>
  );
};

export default PhotoPreview;
